<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'Product Download', to: { path: '/product-download' } },
        { name: 'Create', to: { path: '/product-download/create' } },
      ]"
    ></Breadscrumbs>

    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增Product Download</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <ProductDownloadCreateEdit></ProductDownloadCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ProductDownloadCreateEdit from '@/views/C-4__ProductDownload/c/ProductDownloadCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    ProductDownloadCreateEdit,
  },
  created() {
    this.setDownload({});
  },
  computed: {
    ...mapState('productDownload', [
      'download',
    ]),
  },
  methods: {
    ...mapActions('productDownload', {
      saveDownload: 'save',
      setDownload: 'setDownload',
    }),
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      this.saveDownload(this.download).then(() => {
        this.$router.push({ name: 'ProductDownload' });
      });
    },
  },
};
</script>

<style></style>
